export default "__VITE_ASSET__127cfaba__"